import React from 'react';
import classNames from 'classnames';
import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  getDefaultProductInfoComponents,
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductImage,
  ProductInfoCarousel,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';

import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

import style from '../product.module.scss';
import styleVariation from './ProductCardWithBorder.module.scss';

const ProductCardWithBorder: React.FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
}) => {
  const { product, isSpecial, variants, weightVariant, compoundList } =
    useProductContext();

  const availableInfo = getDefaultProductInfoComponents(product, compoundList);

  return (
    <div
      className={classNames(style.product, styleVariation.product, className)}
    >
      <ProductLinkWrapper
        analyticsListName={analyticsListName}
        isInternalWrapper
        product={product}
      >
        <div className={styleVariation.product__image_container}>
          <ProductImage
            className={styleVariation.product__image}
            product={product}
          />
          <div className={styleVariation.actions__body}>
            <ProductActionFavorite
              className={classNames(style.favorite_action)}
              product={product}
            />
          </div>
          <ProductBadgeContainer
            className={styleVariation.product_badge__container}
            key="badge-container"
            product={product}
            weightVariant={weightVariant}
          />
          <ProductInfoCarousel
            className={styleVariation.variation__info_carousel}
            classWrapper={styleVariation.variation__info_carousel_wrapper}
            direction="vertical"
          >
            {availableInfo}
          </ProductInfoCarousel>
        </div>
        <div
          className={classNames(
            style.product__body,
            styleVariation.product__body,
          )}
        >
          <ProductName name={product?.name || NOT_DEFINED} />
          <ProductPrice
            className={styleVariation.product__price_container}
            elementVariants={<ProductVariants />}
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            type="expanded-tax"
            weightVariant={weightVariant}
          />
        </div>
        <div
          className={classNames(
            style.product__actions_footer_button,
            styleVariation.product__actions_footer_button,
            {
              [style.product__actions_footer_button_disabled]:
                product?.isLowStock,
              [style.product__actions_footer_button_large_card]: isLargeCard,
            },
          )}
        >
          <Counter
            actionTheme="link"
            className={classNames(style.actions__counter_button, {
              [style.actions__counter_button_large_card]: isLargeCard,
            })}
            classNameCounter={style.actions__counter_button_form}
            onCard
            product={product}
            selectedWeightVariant={weightVariant}
            showIcon
          />
        </div>
      </ProductLinkWrapper>
    </div>
  );
};

export { ProductCardWithBorder };
